import sizePresetsConfig from '../configs/headerLogoImagePresetSizesConfig';
import getImageFitSize from '../../../utils/getImageFitSize';

const restrictLogoSizeByHeaderSize = (logoSize, headerSize) => {
  const { width: headerWidth, height: headerHeight } = headerSize;

  const { width: customWidth, height: customHeight } = logoSize;

  const height = Math.min(headerHeight, customHeight);
  const width = Math.min(headerWidth, customWidth);
  return { width, height };
};

const getLogoSizeBySizePreset = (sizePreset, headerSize) => {
  const { width: headerWidth, height: headerHeight } = headerSize;

  return {
    width: headerWidth * sizePresetsConfig[sizePreset],
    height: headerHeight * sizePresetsConfig[sizePreset],
  };
};

const getLogoImageFitSize = ({ logoSize, imageSize }) => {
  const { width: containerWidth, height: containerHeight } = logoSize;
  const { width: imageWidth, height: imageHeight } = imageSize;

  return getImageFitSize(
    containerWidth,
    containerHeight,
    imageWidth,
    imageHeight,
  );
};

export const calculateLogoSize = ({
  size,
  sizePreset,
  headerSize,
  imageSize,
  restrictionEnabled,
}) => {
  const logoSize = size || getLogoSizeBySizePreset(sizePreset, headerSize);

  const restrictedLogoSize = restrictionEnabled
    ? restrictLogoSizeByHeaderSize(logoSize, headerSize)
    : logoSize;

  return getLogoImageFitSize({ logoSize: restrictedLogoSize, imageSize });
};
